import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43f8a391"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "worp" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "worp_operate" }
const _hoisted_4 = { class: "worp_footer_num" }
const _hoisted_5 = { class: "conten" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slot_title" }, "密码", -1))
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = { class: "worp_end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "开启功能后，只能一个设备登录", -1))
const _hoisted_10 = { class: "worp_swt" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formNmbertext formNmbertextmar" }, "用户名：", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formNmbertext" }, "密码：", -1))
const _hoisted_13 = { class: "set_modal" }
const _hoisted_14 = { class: "set_modal_content" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "set_modal_content_title" }, "标题文案：", -1))
const _hoisted_16 = { class: "set_modal_content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "set_modal_content_title" }, "用户名输入框提示：", -1))
const _hoisted_18 = { class: "set_modal_content" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "set_modal_content_title" }, "密码输入框提示：", -1))
const _hoisted_20 = { class: "set_modal_content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "set_modal_content_title" }, "登录按钮文案：", -1))

import http from '@/api/live';
import CDelModal from '@/components/CDelModal.vue';
import { RootModal } from '@/components/CDelModal.vue';
import { ref, computed, unref, reactive } from 'vue';
import { Input, Table, Pagination, Radio, Popover, Modal, Upload, message, notification } from 'ant-design-vue';
import { SearchOutlined } from '@ant-design/icons-vue';
// const aForm = Form;
// const aFformItem = Form.item;
import { Key } from 'ant-design-vue/lib/_util/type';
import { getToken } from '@/plugins/cookie';
import { useStore } from 'vuex';
import router from '@/router';
import { getCurrentInstance } from 'vue';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { onExport } from '@/components/CExport'; //导出
import https from '@/api/exportList';

interface addnumberType {
  name: string;
  password: string;
}
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

const __default__ = { name: 'UserWhiteList' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const aTable = Table;
const aInputSearch = Input.Search;
const aPagination = Pagination;
const aRadioGroup = Radio.Group;
const aPopover = Popover;
const aModal = Modal;
const aUpload = Upload;
const liveBroadcastingRoomId = router.currentRoute.value.params.studioId;
// console.log('id', liveBroadcastingRoomId);
let token = getToken();
const store = useStore();
const form = computed(() => store.state.authorizView.userWhite);
const updateForm = (type: number) => {
  message.destroy();
  if (form.value.user_whitelist_status && !type) {
    store.commit('authorizView/checkUserWhiteSwitch');
  }
  store.commit('authorizView/setUserWhitelist', form.value);
};
const search = ref();
const addNumberVisible = ref<boolean>(false);
const addNumber = () => {
  addNumberVisible.value = !addNumberVisible.value;
};

const addNumberForm = ref<addnumberType>({
  name: '',
  password: '',
});
const userWhiteListAdd = () => {
  message.destroy();
  const data = {
    studio_id: liveBroadcastingRoomId,
    name: addNumberForm.value.name,
    password: addNumberForm.value.password,
  };
  http
    .userWhiteListAdd(data)
    .then((res) => {
      addNumberVisible.value = false;
      message.success(res.data.message);
      userWhitelist();
      addNumberForm.value.name = '';
      addNumberForm.value.password = '';
    })
    .catch((res) => {
      message.error(res.data.error);
      // message.error(res.data.message);
    });
};
const delModal = reactive<RootModal>({
  title: '提示',
  visible: false,
  loading: false,
});
const openDelModal = () => {
  delModal.loading = !delModal.loading;
};
const openDelAllModal = () => {
  delModal.visible = !delModal.visible;
};
const showLoading = ref<boolean>(false);
const userWhitelistData = ref([]);
const pageConfigure = reactive({
  current: 1, // 当前页
  pageSize: 10, // 每页条数
  totalSize: 10, // 总数
  options: ['10', '20', '30', '40', '50'], // 选项
});
const userWhitelist = () => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    page: pageConfigure.current,
    page_num: pageConfigure.pageSize,
    keywords: search.value,
  };
  showLoading.value = true;
  http
    .userWhitelist({ params: data })
    .then((res) => {
      userWhitelistData.value = res.data.data.data;
      pageConfigure.totalSize = res.data.data.total;
      pageConfigure.current = res.data.data.current_page;
      showLoading.value = false;
    })
    .catch(() => {
      // message.error(res.data.message);
      showLoading.value = false;
    });
};
userWhitelist();
const fileList = ref([]);
const handleChange = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    userWhitelist();
    message.success(` 导入成功！`);
  }
};
// 清空
const userWhiteListDel = () => {
  openDelAllModal();
  const data = {
    studio_id: liveBroadcastingRoomId,
  };
  http.userWhiteListDel(data).then((res) => {
    selectedRowKeys.value.length = 0;
    message.success(res.data.message);
    userWhitelist();
  });
};
const checkAll = ref(false);
const selectedRowKeys = ref<Key[]>([]);
//如果没有选中，不能删除
const getSelected = computed(() => selectedRowKeys.value.length === 0);
const onSelectChange = (changableRowKeys: Key[]) => {
  // console.log('selectedRowKeys changed: ', changableRowKeys);
  selectedRowKeys.value = changableRowKeys;
};
const rowSelection = computed(() => {
  return {
    selectedRowKeys: unref(selectedRowKeys),
    onChange: onSelectChange,
  };
});
const onSelectAllChange = () => {
  if (checkAll.value) {
    selectedRowKeys.value = userWhitelistData.value.map((e: any) => e.id);
  } else {
    selectedRowKeys.value = [];
  }
};
// 删除
const delSelect = (id: number) => {
  selectedRowKeys.value = [id];
  openDelModal();
};
const userWhitelistDelete = () => {
  delModal.loading = false;
  const data = {
    studio_id: liveBroadcastingRoomId,
    ids: selectedRowKeys.value,
  };
  http.userWhitelistDelete(data).then((res) => {
    selectedRowKeys.value.length = 0;
    message.success(res.data.message);
    userWhitelist();
  });
};
const showSize = () => {
  userWhitelist();
};
const columns = [
  {
    title: '用户名',
    dataIndex: 'name',
    width: '150px',
    align: 'center',
    key: 'mobile',
  },
  {
    // title: '密码',
    dataIndex: 'password',
    width: '',
    align: '',
    key: 'password',
    slots: { title: 'customTitle', customRender: 'password' },
  },
  {
    title: '删除',
    dataIndex: 'img',
    width: '130px',
    align: 'center',
    key: 'action',
    slots: { customRender: 'action' },
  },
];

// 输入框限制
// value=value.replace(/[\u4E00-\u9FA5]/g,'')
// const ononKeyUp = (e: any) => {
//   if (/[\u4E00-\u9FA5]/g.test(e.target.value)) {
//     addNumberForm.value.password = e.target.value.replace(/[\u4E00-\u9FA5]/g, '');
//   }
// };
//下载模板
const DownloadTemplate = () => {
  location.href = process.env.VUE_APP_OTHER_LINK+'/user_whitelist.xls';
};
// 地域分布导出
const { proxy }: any = getCurrentInstance();
const corn = ref(1);
const messageTip = ref();
const ExportTemplate = useDebounce(() => {
  const data = {
    studio_id: liveBroadcastingRoomId,
    type: 31,
    is_cron_download: corn.value,
  };
  https
    .excel_regional_distribution({ params: data })
    .then((res: any) => {
      messageTip.value = res.data.message;
      openNotificationWithIcon('success');
    })
    .catch((res: any) => {
      messageTip.value = res.data.error
      openNotificationWithIcon('error');
    });
});
// 导出成功时发出通知
const openNotificationWithIcon = (type: string) => {
  notification[type]({
    message: messageTip.value,
   duration: 5,
  });
};
const seniorSetModal = reactive<RootModal>({
  title: '高级设置',
  visible: false,
  loading: false,
});
const openSeniorSetModal = () => {
  seniorSetModal.visible = !seniorSetModal.visible;
};

const updataSeniorSetData = () => {
  store.commit('authorizView/setUserWhitelist', form.value);
};
const saveSeniorSet = useDebounce(async () => {
  const resMsg = await store.dispatch('authorizView/saveAothorize');
  message.success(resMsg);
  openSeniorSetModal();
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_component_a_button, {
            type: "primary",
            class: "worp_head_but",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addNumber()))
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加观众")
            ]),
            _: 1
          }),
          _createVNode(_unref(aUpload), {
            "file-list": fileList.value,
            "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => ((fileList).value = $event)),
            name: "file",
            accept: ".xls,.xlsx,.csv",
            multiple: true,
            action: "/api/v1/live/user_whitelist_import",
            showUploadList: false,
            data: 
            (file) => ({
              studio_id: _unref(liveBroadcastingRoomId),
              excel: file,
            })
          ,
            headers: { token: _unref(token) },
            onChange: _cache[2] || (_cache[2] = (info) => handleChange(info)),
            class: "worp_head_up"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                class: "worp_head_but"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 批量导入")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["file-list", "data", "headers"]),
          _createVNode(_unref(aInputSearch), {
            class: "worp_head_search",
            value: search.value,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((search).value = $event)),
            onChange: userWhitelist,
            placeholder: "请输入用户名"
          }, {
            enterButton: _withCtx(() => [
              _createVNode(_component_a_button, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(SearchOutlined), {
                    class: "worp_head_search_svg",
                    onClick: userWhitelist
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_button, {
            type: "link",
            class: "worp_footer_down",
            onClick: DownloadTemplate
          }, {
            default: _withCtx(() => [
              _createTextVNode("下载Excel模板")
            ]),
            _: 1
          }),
          _createVNode(_component_a_button, {
            type: "link",
            class: "worp_footer_down",
            onClick: _unref(ExportTemplate),
            disabled: userWhitelistData.value.length < 1
          }, {
            default: _withCtx(() => [
              _createTextVNode("导出")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createElementVNode("p", _hoisted_4, "观众数量" + _toDisplayString(pageConfigure.totalSize) + "条", 1),
          _createVNode(_component_a_checkbox, {
            checked: checkAll.value,
            "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((checkAll).value = $event)),
            disabled: userWhitelistData.value.length === 0,
            onChange: onSelectAllChange
          }, {
            default: _withCtx(() => [
              _createTextVNode("全选")
            ]),
            _: 1
          }, 8, ["checked", "disabled"]),
          _createVNode(_component_a_button, {
            class: "del_boder",
            danger: "",
            disabled: _unref(getSelected),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (openDelModal()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 删除 ")
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            class: "worp_empty",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (openDelAllModal())),
            disabled: userWhitelistData.value.length === 0
          }, {
            default: _withCtx(() => [
              _createTextVNode("清空")
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode(CDelModal, {
          visible: delModal.visible,
          centered: "",
          close: openDelAllModal,
          ok: userWhiteListDel
        }, {
          title: _withCtx(() => [
            _createTextVNode("此操作将清空该文件，是否继续？")
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(CDelModal, {
          visible: delModal.loading,
          centered: "",
          close: openDelModal,
          ok: userWhitelistDelete
        }, null, 8, ["visible"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(aTable), {
          loading: showLoading.value,
          columns: columns,
          "data-source": userWhitelistData.value,
          "row-selection": _unref(rowSelection),
          pagination: false,
          rowKey: "id"
        }, {
          customTitle: _withCtx(() => [
            _hoisted_6
          ]),
          action: _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "link",
              class: "cancel_but",
              onClick: ($event: any) => (delSelect(record.id))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_icon, { "icon-class": "whiteList_del" }),
                _createTextVNode(_toDisplayString(record.action), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["loading", "data-source", "row-selection"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(aPagination), {
          current: pageConfigure.current,
          "onUpdate:current": _cache[7] || (_cache[7] = ($event: any) => ((pageConfigure.current) = $event)),
          pageSize: pageConfigure.pageSize,
          "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((pageConfigure.pageSize) = $event)),
          pageSizeOptions: pageConfigure.options,
          total: pageConfigure.totalSize,
          onShowSizeChange: showSize,
          onChange: showSize,
          "show-quick-jumper": "",
          "show-less-items": "",
          "show-size-changer": "",
          class: "worp_footer_page"
        }, null, 8, ["current", "pageSize", "pageSizeOptions", "total"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createVNode(_unref(aPopover), {
            trigger: "hover",
            placement: "topLeft"
          }, {
            content: _withCtx(() => [
              _hoisted_9
            ]),
            default: _withCtx(() => [
              _createTextVNode(" 唯一登录： ")
            ]),
            _: 1
          }),
          _createVNode(_unref(aRadioGroup), {
            value: _unref(form).user_whitelist_point_status,
            "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(form).user_whitelist_point_status) = $event)),
            onInput: _cache[10] || (_cache[10] = ($event: any) => (updateForm(1)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, { value: true }, {
                default: _withCtx(() => [
                  _createTextVNode("开启")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: false }, {
                default: _withCtx(() => [
                  _createTextVNode("关闭")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _createElementVNode("div", {
          class: "header_set",
          onClick: openSeniorSetModal
        }, "高级设置")
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createTextVNode(" 功能开关： "),
      _createVNode(_component_a_switch, {
        checked: _unref(form).user_whitelist_status,
        "onUpdate:checked": _cache[11] || (_cache[11] = ($event: any) => ((_unref(form).user_whitelist_status) = $event)),
        onChange: _cache[12] || (_cache[12] = ($event: any) => (updateForm(0)))
      }, null, 8, ["checked"])
    ]),
    _createVNode(_unref(aModal), {
      visible: addNumberVisible.value,
      "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((addNumberVisible).value = $event)),
      centered: "",
      title: "添加观众"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (addNumber()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_prmary bg_img",
          onClick: _cache[16] || (_cache[16] = ($event: any) => (userWhiteListAdd()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_11,
          _createVNode(_component_a_input, {
            class: "formNmber",
            value: addNumberForm.value.name,
            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((addNumberForm.value.name) = $event)),
            placeholder: "请输入用户名"
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _createVNode(_component_a_input, {
            class: "formNmber",
            type: "password",
            value: addNumberForm.value.password,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((addNumberForm.value.password) = $event)),
            placeholder: "请输入密码"
          }, null, 8, ["value"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(aModal), {
      visible: seniorSetModal.visible,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((seniorSetModal.visible) = $event)),
      centered: "",
      title: seniorSetModal.title,
      width: "600px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: openSeniorSetModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_prmary bg_img",
          onClick: _unref(saveSeniorSet)
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_component_a_input, {
              value: _unref(form).user_whitelist_setting.title,
              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(form).user_whitelist_setting.title) = $event)),
              placeholder: "请输入标题文案",
              onChange: updataSeniorSetData
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_a_input, {
              value: _unref(form).user_whitelist_setting.account,
              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_unref(form).user_whitelist_setting.account) = $event)),
              placeholder: "请输入用户名输入框提示",
              onChange: updataSeniorSetData
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_a_input, {
              value: _unref(form).user_whitelist_setting.password,
              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_unref(form).user_whitelist_setting.password) = $event)),
              placeholder: "请输入密码输入框提示",
              onChange: updataSeniorSetData
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_a_input, {
              value: _unref(form).user_whitelist_setting.login,
              "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_unref(form).user_whitelist_setting.login) = $event)),
              placeholder: "请输入登录按钮文案",
              onChange: updataSeniorSetData
            }, null, 8, ["value"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}
}

})